import {
  Button,
  Card,
  Col,
  Drawer,
  Form,
  Input,
  notification,
  Row,
  Select
} from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import React from 'react'
import { connect } from 'react-redux'

const { Option } = Select

@Form.create()
class EditTable extends React.Component {
  // formRef = React.createRef
  constructor(props) {
    super(props)
    this.state = {
      image: '',
      description: '',
      loading: false
    }
  }

  submitForm = async (e) => {
    let { editTable, onClose, updateTableData } = this.props
    let { image, description } = this.state
    if (!image || (image && !image.name)) {
      notification.warning({
        message: 'Choose Image'
      })
      return
    }

    if (updateTableData) {
      let updatedObj = {
        ...editTable,
        image,
        fileName: image ? image.name : ''
      };
      if (description !== undefined) {
         updatedObj.description = description;
      }
      updateTableData(updatedObj, editTable.index);
      notification.success({ message: 'Image updated locally. Please SUBMIT to save.' })
      onClose()
    }
  }

  componentDidMount() {
    this.setState({
      description: this.props.editTable.description
    })
  }

  render() {
    let { visible, onClose, title, onChange, editTable } = this.props
    return (
      <>
        <Drawer
          title={`Edit ${title}`}
          width={'70%'}
          visible={visible}
          maskClosable={true}
          placement='right'
          onClose={onClose}>
          <Card>
            <Form hideRequiredMark className={'inputForm'}>
              <Row>

                <Col span={8}>
                  <Form.Item label='Image'>
                    <Input
                      type='file'
                      className='form-control'
                      accept='image/png, image/gif, image/jpeg'
                      onChange={e => {
                        let file = e.target.files[0]
                        this.setState({
                          image: file,
                          previewPath: URL.createObjectURL(file)
                        })
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item>
                    <Button
                      type='primary'
                      onClick={() => {
                        this.submitForm()
                      }}>
                      Update
                    </Button>
                  </Form.Item>
                </Col>
                {(this.state.previewPath || (editTable && editTable.image && editTable.image.path)) && (
                  <Col span={24}>
                    <Form.Item label="Preview">
                      <img 
                        src={this.state.previewPath || editTable.image.path} 
                        style={{ height: 200, width: 'auto', borderRadius: 4, border: '1px solid #ddd' }} 
                        alt="Image Preview" 
                      />
                    </Form.Item>
                  </Col>
                )}
              </Row>
            </Form>
          </Card>
        </Drawer>
      </>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(
  null,
  mapDispatchToProps
)(EditTable)
